import '../helper/global-jquery';
import 'slick-carousel';

const CAROUSELS = $('.ce--vd_carousel,.ce--vd_news_carousel');

CAROUSELS.each((index, el) => {
  const $slider = $(el).find('.vd-slider.vd-slider--slick');
  const $dots = $(el).find('.vd-slick-dots');
  const $pArrow = $(el).find('.vd-slick-prev');
  const $nArrow = $(el).find('.vd-slick-next');
  const isGallery = $(el).find('.vd-slide').hasClass('vd-slide--image-gallery');
  const $controls = $(el).find('.vd-slick-dots ul');

  const slidesToShow = parseInt($slider.attr('data-slides-to-show'));
  const slidesToScroll = parseInt($slider.attr('data-slides-to-scroll'));

  $slider.on('init', (e) => {
    const $images = $slider.find('img');

    $images.each((index, img) => {
      $(img)
        .on('load', function (e) {
          const width = e.currentTarget.naturalWidth;
          const height = e.currentTarget.naturalHeight;
          const figureEl = e.currentTarget.closest('figure');
          let format = '';

          if (width > height) format = 'landscape';
          if (width < height) format = 'portrait';
          if (width === height) format = 'square';

          if (img.dataset.uid) {
            if (figureEl) figureEl.dataset.format = format;
            else e.currentTarget.dataset.format = format;
          }
        })
        .attr('src', $(img).attr('src'));
    });
  });

  $slider.slick({
    lazyLoad: 'ondemand',
    adaptiveHeight: false,
    dots: isGallery ? false : true,
    arrows: true,
    appendDots: $dots,
    prevArrow: $pArrow,
    nextArrow: $nArrow,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    swipe: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          swipe: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: isGallery ? false : true,
          adaptiveHeight: true,
        },
      },
    ],
  });
});
